import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createWorkspace, getWorkspaces, updateWorkspace } from '@/features/workspaces/api';
const WORKSPACES_QUERY_KEY = ['workspaces'];
export function useWorkspaces() {
    return useQuery({
        queryKey: WORKSPACES_QUERY_KEY,
        queryFn: getWorkspaces,
        select: (response) => response.data,
    });
}
export function useCreateWorkspace() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (name) => createWorkspace(name),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: WORKSPACES_QUERY_KEY });
        },
    });
}
export function useUpdateWorkspace() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name }) => updateWorkspace(id, name),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: WORKSPACES_QUERY_KEY });
        },
    });
}
